/* The Fragrance World, product page (sections/fw-product.liquid).

   Size pills are radios named "id", so the form already posts the right variant with no
   script. This file adds: price, compare-at, saving, button state and URL follow the
   selected size; the gallery shows the size's photo; thumbnails switch the photo; the
   quantity stepper; add to cart without leaving the page (header count updates); and
   the "You may also like" section loads. If the cart request fails for any reason other
   than a message Shopify gives us, the form submits the normal way. */
(() => {
  const root = document.querySelector('[data-fwp]');
  if (!root) return;
  const data = JSON.parse(document.querySelector('[data-fwp-json]').textContent);
  const form = root.querySelector('[data-fwp-form]');
  const $ = (s, el = root) => el.querySelector(s);

  const money = cents => {
    const fmt = data.moneyFormat || '${{amount}}';
    const n = (cents / 100);
    const fixed = (v, d, t, s) => {
      const [a, b] = v.toFixed(d).split('.');
      return a.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (b ? s + b : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fixed(n, 2, ',', '.'),
      amount_no_decimals: fixed(n, 0, ',', '.'),
      amount_with_comma_separator: fixed(n, 2, '.', ','),
      amount_no_decimals_with_comma_separator: fixed(n, 0, '.', ','),
    }[k] ?? fixed(n, 2, ',', '.')));
  };

  /* ---------------------------------------------------------------- gallery */
  const stage = $('[data-stage]');
  const show = id => {
    if (!id || !stage) return;
    const img = stage.querySelector(`[data-image="${id}"]`);
    if (!img) return;
    stage.querySelectorAll('img.on').forEach(i => i !== img && i.classList.remove('on'));
    img.removeAttribute('loading');
    img.classList.add('on');
    root.querySelectorAll('[data-thumb]').forEach(b =>
      b.dataset.thumb === String(id) ? b.setAttribute('aria-current', 'true') : b.removeAttribute('aria-current'));
  };
  root.querySelectorAll('[data-thumb]').forEach(b => b.addEventListener('click', () => show(b.dataset.thumb)));

  /* ------------------------------------------------------------ variants */
  const price = $('[data-price]'), compare = $('[data-compare]'), save = $('[data-save]');
  const add = $('[data-add]'), addLabel = $('[data-add-label]'), sizeName = $('[data-size-name]');
  const note = $('[data-note]');
  const current = () => {
    const el = form.querySelector('input[name="id"]:checked, select[name="id"], input[type="hidden"][name="id"]');
    return el && data.variants.find(v => String(v.id) === el.value);
  };
  const render = (v, push) => {
    if (!v) return;
    price.textContent = money(v.price);
    const off = v.compare > v.price;
    compare.hidden = !off; save.hidden = !off;
    if (off) {
      compare.lastChild.textContent = money(v.compare);
      save.textContent = 'Save ' + money(v.compare - v.price);
    }
    add.disabled = !v.available;
    addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
    if (sizeName) sizeName.textContent = v.title;
    show(v.image);
    note.textContent = ''; note.className = 'fwp-note';
    if (push) {
      const u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u);
    }
  };
  form.addEventListener('change', e => { if (e.target.name === 'id') render(current(), true); });

  /* ------------------------------------------------------------ quantity */
  const qty = $('#fwp-qty');
  root.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click', () => {
    qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.step));
  }));
  qty.addEventListener('change', () => { qty.value = Math.max(1, parseInt(qty.value, 10) || 1); });

  /* --------------------------------------------------------- add to cart */
  const setCount = n => {
    const link = document.querySelector('#hdr .cart');
    if (!link) return;
    let c = link.querySelector('.count');
    if (n > 0 && !c) { c = document.createElement('span'); c.className = 'count'; c.setAttribute('aria-hidden', 'true'); link.appendChild(c); }
    if (c) n > 0 ? (c.textContent = n) : c.remove();
    link.setAttribute('aria-label', `Cart, ${n} ${n === 1 ? 'item' : 'items'}`);
  };
  form.addEventListener('submit', async e => {
    if (!window.fetch || add.disabled) return;
    e.preventDefault();
    add.classList.add('busy'); add.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) {
        if (j.description || j.message) {
          note.className = 'fwp-note err';
          note.textContent = j.description || j.message;
          return;
        }
        throw new Error('cart add failed');
      }
      const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      setCount(cart.item_count);
      note.className = 'fwp-note';
      note.innerHTML = 'Added to your cart. <a href="/cart">View cart</a>';
      addLabel.textContent = 'Added';
      setTimeout(() => { const v = current(); if (v && v.available) addLabel.textContent = 'Add to cart'; }, 2200);
    } catch (_) {
      form.submit();
    } finally {
      add.classList.remove('busy'); add.removeAttribute('aria-busy');
    }
  });

  /* ---------------------------------------------------------- also like */
  const recs = document.querySelector('[data-recs]');
  if (recs && !recs.children.length && recs.dataset.url) {
    const load = () => fetch(recs.dataset.url).then(r => r.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recs]');
      if (fresh && fresh.children.length) recs.innerHTML = fresh.innerHTML;
    }).catch(() => {});
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(es => { if (es.some(x => x.isIntersecting)) { io.disconnect(); load(); } }, { rootMargin: '600px' });
      io.observe(recs);
    } else load();
  }
})();
